import _ceil from 'lodash/ceil';
import _orderBy from 'lodash/orderBy';
import dayjs from 'dayjs';
import lookDao from '../../../dao/lookDao';
import smbUtils from '../../../utils/smbUtils';

const LIST_LOOKS = 'pages/products/listlooks/LIST_LOOKS';
const LIST_LOOKS_SUCCESS = 'pages/products/listlooks/LIST_LOOKS_SUCCESS';
const PAGE = 'pages/products/listlooks/PAGE';
const SIZE = 'pages/products/listlooks/Size';
const SORT = 'pages/products/listlooks/SORT';
const DELETE_LOOK = 'pages/products/listlooks/DELETE_LOOK';
const DELETE_LOOK_SUCCESS = 'pages/products/listlooks/DELETE_LOOK_SUCCESS';
const SEARCH = 'pages/products/listlooks/SEARCH';
const RESET_SEARCH = 'pages/products/listlooks/RESET_SEARCH';
const FILTER_LOOKS = 'pages/products/listlooks/FILTER_LOOKS';
const FILTER_LOOKS_SUCCESS = 'pages/products/listlooks/FILTER_LOOKS_SUCCESS';
const COUNT_ENABLED = 'pages/products/listlooks/COUNT_ENABLED';
const COUNT_ENABLED_SUCCESS = 'pages/products/listlooks/COUNT_ENABLED_SUCCESS';

const initialState = {
  looks: [],
  allLooks: [],
  isLoaded: false,
  grid: {
    sort: 'createdTime',
    asc: false,
    pageIndex: 1,
    pageSize: 10,
    querySize: 100,
    pages: 1,
    totalSize: 0,
  },
  numberOfEnabled: null,
  searchParams: {},
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LIST_LOOKS:
      return {
        ...state,
        isLoaded: false,
      };
    case LIST_LOOKS_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        looks: action.json.results,
        allLooks: action.json.results,
      };
    case DELETE_LOOK:
      return {
        ...state,
      };
    case DELETE_LOOK_SUCCESS:
      return {
        ...state,
      };
    case FILTER_LOOKS:
      return {
        ...state,
      };
    case FILTER_LOOKS_SUCCESS:
      return {
        ...state,
        looks: action.json,
        grid: {
          ...state.grid,
          totalSize: action.json.length,
          pages: _ceil(action.json.length / state.grid.pageSize),
        },
      };
    case PAGE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageIndex: action.pageIndex,
        },
      };
    case SIZE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageSize: action.pageSize,
          pages: _ceil(state.allLooks.length / action.pageSize),
          pageIndex: 1,
        },
      };
    case SORT:
      return {
        ...state,
        grid: {
          ...state.grid,
          sort: action.sort,
          asc: state.grid.sort === action.sort ? !state.grid.asc : false,
        },
      };
    case SEARCH:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.params,
        },
        grid: {
          ...state.grid,
          pageIndex: 1,
        },
      };
    case RESET_SEARCH:
      return {
        ...state,
        searchParams: {},
      };
    case COUNT_ENABLED:
      return {
        ...state,
        numberOfEnabled: null,
      };
    case COUNT_ENABLED_SUCCESS:
      return {
        ...state,
        numberOfEnabled: action.numberOfEnabled,
      };
    default:
      return state;
  }
};

export function listLooks() {
  return (dispatch, getState) => {
    dispatch({
      type: LIST_LOOKS,
    });
    return lookDao
      .listAllLooks(buildQueryString(getState()))
      .then(json => dispatch(listLooksSuccess(json)));
  };
}

function listLooksSuccess(json) {
  return dispatch => {
    dispatch({
      type: LIST_LOOKS_SUCCESS,
      json,
    });
    return dispatch(filterLooks());
  };
}

function buildQueryString(rootState) {
  const grid = rootState.pages.products.listlooks.grid;
  return {
    sortBy: grid.sort,
    asc: grid.asc,
    pageIndex: initialState.grid.pageIndex,
    pageSize: grid.querySize,
  };
}

export function deleteLook(lookId) {
  return dispatch => {
    dispatch({
      type: DELETE_LOOK,
    });
    return lookDao.deleteLook(lookId).then(json => {
      dispatch(deleteLookSuccess(json));
      dispatch(countEnabled());
    });
  };
}

function deleteLookSuccess(json) {
  return dispatch => {
    dispatch(listLooks());
    return dispatch({
      type: DELETE_LOOK_SUCCESS,
      json,
    });
  };
}

function filterLooks() {
  return (dispatch, getState) => {
    const grid = getState().pages.products.listlooks.grid;
    let looks = getState().pages.products.listlooks.allLooks;
    const filterParams = smbUtils.omit(
      getState().pages.products.listlooks.searchParams
    );
    if (filterParams.lookNo) {
      looks = looks.filter(
        s =>
          s.lookNo &&
          s.lookNo.search(new RegExp(filterParams.lookNo, 'i')) !== -1
      );
    }
    if (filterParams.lookName) {
      looks = looks.filter(s =>
        s.lookName
          ? s.lookName.search(new RegExp(filterParams.lookName, 'i')) !== -1
          : s.i18n &&
            s.i18n.enu &&
            s.i18n.enu.lookName.search(
              new RegExp(filterParams.lookName, 'i')
            ) !== -1
      );
    }
    if (filterParams.createdTimeFrom) {
      looks = looks.filter(s => {
        const from = dayjs(filterParams.createdTimeFrom).valueOf();
        const to = dayjs(filterParams.createdTimeTo).valueOf();
        const createdTime = dayjs(s.createdTime).valueOf();
        return from <= createdTime && createdTime <= to;
      });
    }
    if (filterParams.lastModifiedFrom) {
      looks = looks.filter(s => {
        const from = dayjs(filterParams.lastModifiedFrom).valueOf();
        const to = dayjs(filterParams.lastModifiedTo).valueOf();
        const createdTime = dayjs(s.createdTime).valueOf();
        return from <= createdTime && createdTime <= to;
      });
    }
    looks = _orderBy(looks, grid.sort, grid.asc ? 'asc' : 'desc');
    return dispatch(filterLooksSuccess(looks));
  };
}

function filterLooksSuccess(json) {
  return {
    type: FILTER_LOOKS_SUCCESS,
    json,
  };
}

export function page(params) {
  return {
    type: PAGE,
    pageIndex: params.selected + 1,
  };
}

export function size(pageSize) {
  return {
    type: SIZE,
    pageSize,
  };
}

export function sort(sort) {
  return dispatch => {
    dispatch({
      type: SORT,
      sort,
    });
    return dispatch(filterLooks());
  };
}

export function search(params) {
  return dispatch => {
    dispatch({
      type: SEARCH,
      params,
    });
    return dispatch(filterLooks());
  };
}

export function resetSearch() {
  return dispatch => {
    dispatch({
      type: RESET_SEARCH,
    });
    return dispatch(filterLooks());
  };
}

export function countEnabled() {
  return dispatch => {
    dispatch({type: COUNT_ENABLED});
    return lookDao.countEnabled().then(r => {
      dispatch({type: COUNT_ENABLED_SUCCESS, numberOfEnabled: r.count});
    });
  };
}
